export default __webpack_public_path__ + "6453891f963fb4b2c932ef0065b0088a.png";